import { Form, json, redirect, useActionData } from "react-router-dom";
import domain from "../domain";
import classes from "./AuthForm.module.css";
import { getFirstActiveBranch } from "../util/multipleBranch/getActiveBranchId";
import {deleteLocalStorage} from "../util/deleteLocalStorage";

function AuthForm() {
  console.log("Render AuthForm");
  const actionData = useActionData();
  console.log(actionData);

  return (
    <>
      <div className={classes.authformContainer}>
        <Form method="post" className={classes.form}>
          <h1> Log in </h1>
          {actionData && (
            <div className={classes.errorContainer}>
              <p>{actionData.message}</p>
            </div>
          )}
          <p>
            <label htmlFor="email">Email</label>
            <input id="email" type="email" name="email" />
          </p>
          <p>
            <label htmlFor="password">Password</label>
            <input id="password" type="password" name="password" required />
          </p>
          <div className={classes.actions}>
            <button>Login</button>
          </div>
          <p>
            {/* <a className={classes.signupLink} href="/signup">
            Click to create new account
          </a> */}
          </p>
        </Form>
      </div>
    </>
  );
}

export default AuthForm;

export async function action({ request }) {
  console.log("login req hit");
  const data = await request.formData();
  const authData = {
    email: data.get("email"),

    password: data.get("password"),
  };

  try{

  const response = await fetch(`${domain}/ad/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(authData),
  });

  

  if (response.status === 401) {
    return response;
  }

  if (!response.ok) {
    throw json({ message: "could not create account" }, { status: 500 });
  }

  if (response.status === 200) {
    const resData = await response.json();
    console.log(resData);

    // if logged in id is different from already stored in local storage
    if (localStorage.getItem("id") != resData.id) {
      console.log("different user logged in, clearing local storage");
    
      deleteLocalStorage();
    }
    localStorage.setItem("id", resData.id);
    localStorage.setItem("hqRid", resData.hqRid);
    localStorage.setItem("restaurantId", resData.restaurantId);
   
    localStorage.setItem("role", resData.role);
    
    if (localStorage.getItem("branches") == null ||localStorage.getItem("branches").length == 0) {
     console.log("setting branches in local storage");
   
     
      if(resData.branch.length < 1){
       
        localStorage.setItem("branches", JSON.stringify([{bId:resData.id,"isActive":true}])); 
      }
      else{
  localStorage.setItem("branches", JSON.stringify(resData.branch)); 
    

      }

      
    }

    return redirect("/");
  }
}

catch (err) {
  console.log("error in login action"); 
  console.log(err);
  return {error : err , message : "Internet Connection Error or Server Down"};
}

  return redirect("/login");
}
